import React, { useState } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import './Auth.css';

import { API_BASE } from '../config/api';
import { jsonHeaders } from '../utils/apiClient';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const response = await fetch(`${API_BASE}/auth/forgot-password?email=${encodeURIComponent(email)}`, {
        method: 'POST',
        headers: jsonHeaders
      });

      if (response.ok) {
        setMessage('If an account exists for that email, we sent a reset link and code.');
      } else {
        setMessage('If an account exists for that email, we sent a reset link and code.');
      }
    } catch (error) {
      setMessage('Failed to send reset email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <Navigation />
      <div className="auth-container">
        <form onSubmit={handleSubmit} className="auth-form">
          <h2>Forgot Password</h2>
          <p>Enter your email to receive a password reset link</p>
          
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          
          <button type="submit" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
          
          {message && (
            <p className={`message ${message.includes('sent') ? 'success' : 'error'}`}>
              {message}
            </p>
          )}
          
          <p className="auth-toggle">
            Remember your password? 
            <a href="/login" className="toggle-link">
              Login here
            </a>
          </p>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;